// Codifications that can be retrieved using web service /getCodifs.htm
// See ticket SAN-15
// See https://mobile-spot.atlassian.net/wiki/spaces/FR/pages/18677787/UserData+Networking+WebServices+request

const CODIFICATIONS_SOURCES = {
  EXHIBIS: 'EXHIBIS'
};
const CODIFICATIONS_ENTITIES = {
  INDIVIDUEVT: 'IndividuEvt'
};
const CODIFICATIONS_NAMES = {
  FONCTION: 'ZL_FONCTION',
  PROFIL: 'ZL_PROFIL',
  SERVICE: 'ZL_SERVICE',
  CENTREINTERET: 'ZL_CENTREINTERET'
};
const CODIFICATION_FONCTION = {
  sourceCode: CODIFICATIONS_SOURCES.EXHIBIS,
  entityCode: CODIFICATIONS_ENTITIES.INDIVIDUEVT,
  nameField: CODIFICATIONS_NAMES.FONCTION
};
const CODIFICATION_PROFIL = {
  sourceCode: CODIFICATIONS_SOURCES.EXHIBIS,
  entityCode: CODIFICATIONS_ENTITIES.INDIVIDUEVT,
  nameField: CODIFICATIONS_NAMES.PROFIL
};
const CODIFICATION_SERVICE = {
  sourceCode: CODIFICATIONS_SOURCES.EXHIBIS,
  entityCode: CODIFICATIONS_ENTITIES.INDIVIDUEVT,
  nameField: CODIFICATIONS_NAMES.SERVICE
};
const CODIFICATION_CENTREINTERET = {
  sourceCode: CODIFICATIONS_SOURCES.EXHIBIS,
  entityCode: CODIFICATIONS_ENTITIES.INDIVIDUEVT,
  nameField: CODIFICATIONS_NAMES.CENTREINTERET
};
const CODIFICATIONS_TO_AUTOMATICALLY_RETRIEVE = [CODIFICATION_FONCTION, CODIFICATION_PROFIL, CODIFICATION_SERVICE, CODIFICATION_CENTREINTERET];
const FETCH_ON_LOGIN_SUCCESS = true;
module.exports = {
  CODIFICATION_FONCTION,
  CODIFICATION_PROFIL,
  CODIFICATION_SERVICE,
  CODIFICATION_CENTREINTERET,
  CODIFICATIONS_TO_AUTOMATICALLY_RETRIEVE,
  FETCH_ON_LOGIN_SUCCESS
};